import { useEffect, useRef, useState } from 'react';

import { Zoom } from '@mui/material';

import { PrimaryButton } from '@/components/Button/PrimaryButton';
import useMediaQuery from '@/hooks/useMediaQuery';
import FVIcon from 'public/assets/logo-original2.svg';
import UploadLogo from 'public/assets/upload_drop.svg';

function TokenCreationStep1({
  setStep1Complete,
  tokenName,
  setTokenName,
  tokenLogo,
  setTokenLogo,
  tokenDescription,
  setTokenDescription,
  tokenSymbol,
  setTokenSymbol,
  setCreateTokenWithAddress,
}: {
  setStep1Complete: Function;
  tokenName: string;
  setTokenName: Function;
  tokenLogo: File;
  setTokenLogo: Function;
  tokenDescription: string;
  setTokenDescription: Function;
  tokenSymbol: string;
  setTokenSymbol: Function;
  setCreateTokenWithAddress: Function;
}) {
  const [isValidInfo, setIsValidInfo] = useState<boolean>(false);
  const isMediaMax550px = useMediaQuery('(max-width : 550px)');
  const isMediaMax1025px = useMediaQuery('(max-width : 1025px)');
  const [isToolTip, setToolTip] = useState(false);
  const tokenInputRef = useRef(null);

  useEffect(() => {
    if (tokenName.trim() && tokenSymbol.trim()) {
      setIsValidInfo(true);
    } else {
      setIsValidInfo(false);
    }
  }, [tokenName, tokenSymbol]);

  return (
    <div className="w-full flex p-2  flex-col items-center h-full">
      <div className="font-bold text-xl pb-8 text-left">
        Create And Distribute Your Own Access-Token for Free
      </div>
      <div className="flex w-full overflow-y-scroll no-scrollbar flex-col h-full">
        <div
          className={`flex flex-row mb-8 text-sm ${
            isMediaMax550px ? 'flex-wrap justify-center' : ''
          } `}
        >
          <div
            onMouseEnter={() => {
              setToolTip(true);
            }}
            onMouseLeave={() => {
              setToolTip(false);
            }}
            onClick={() => {
              setToolTip(!isToolTip);
            }}
            className=" p-4 flex justify-center flip-container relative items-center"
          >
            <div
              className={` ${
                isMediaMax1025px ? 'h-28 w-28 mb-4' : 'h-60 w-60'
              } flipper relative overflow-hidden flex justify-center items-center rounded-full`}
            >
              <img
                src={tokenLogo ? URL.createObjectURL(tokenLogo) : FVIcon.src}
                className="w-full h-full"
                alt="token image"
              />
              <div
                className={`bg-black ${
                  isMediaMax1025px ? 'h-6' : 'h-12'
                } flex justify-center items-center bg-opacity-50 absolute bottom-0 w-full`}
              >
                <p
                  className={`break-words text-white ${
                    isMediaMax1025px ? 'max-h-6 w-16' : 'max-h-12 w-24'
                  } bottom-5  no-scrollbar  overflow-scroll text-md`}
                >
                  {tokenName || 'Fileverse'}
                </p>
              </div>
            </div>
            {tokenDescription !== '' && (
              <Zoom in={isToolTip}>
                <div
                  onMouseEnter={() => {
                    setToolTip(true);
                  }}
                  onMouseLeave={() => {
                    setToolTip(false);
                  }}
                  className="absolute text-left top-0 transition-all duration-200 ease-in-out p-2 max-w-60 rounded-lg text-xs break-words bg-black opacity-70 text-white"
                >
                  <p>{tokenDescription}</p>
                </div>
              </Zoom>
            )}
          </div>
          <div className="flex flex-col w-full">
            <div
              onClick={() => tokenInputRef.current.click()}
              className="border mb-4 cursor-pointer hover:bg-gray-100 rounded p-2 border-gray-400 ml-2 flex justify-center items-center"
            >
              {tokenLogo ? (
                <>
                  <img
                    src={URL.createObjectURL(tokenLogo)}
                    className="w-4 mr-4"
                    alt="upload icon"
                  />
                  <span className="text-lg">
                    {tokenLogo.name.length > 15
                      ? `${tokenLogo.name.substring(
                          0,
                          10
                        )}...${tokenLogo.name.substring(
                          tokenLogo.name.indexOf('.')
                        )}`
                      : tokenLogo.name}
                  </span>
                </>
              ) : (
                <>
                  <img
                    src={UploadLogo.src}
                    className="w-4 mr-4"
                    alt="upload icon"
                  />
                  <span className="text-lg">Select Token Image</span>
                </>
              )}
            </div>
            <input
              ref={tokenInputRef}
              type="file"
              id="file"
              name="file"
              accept="image/*"
              onChange={(e) => setTokenLogo(e.target.files[0])}
              className="border mb-4 hidden rounded p-2 border-gray-400 ml-2"
            />
            <input
              placeholder="Enter Token Name"
              id="name"
              value={tokenName}
              onChange={(e) => setTokenName(e.target.value)}
              className="border rounded p-2 border-gray-400 ml-2"
            />
            <input
              placeholder="Enter Token Symbol"
              id="symbol"
              value={tokenSymbol}
              onChange={(e) => setTokenSymbol(e.target.value)}
              className="border rounded p-2 border-gray-400  ml-2 my-4"
            />
            <textarea
              placeholder="Enter Token Description"
              rows={4}
              id="description"
              className="border rounded resize-none p-2 border-gray-400  ml-2"
              value={tokenDescription}
              onChange={(e) => setTokenDescription(e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className=" flex pt-4  w-full">
        <PrimaryButton onClick={() => setCreateTokenWithAddress(false)}>
          <span>Close</span>
        </PrimaryButton>
        <div className="w-full justify-end flex">
          <PrimaryButton
            onClick={() => setStep1Complete(true)}
            disabled={!isValidInfo}
          >
            <span>Next</span>
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
}
export default TokenCreationStep1;
